'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.duplicateMultipleElements = exports.duplicateElement = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Actions


// Util


// Constants


var _elementActions = require('../../../common/elements/elementActions');

var _elementActions2 = require('../elementActions');

var _elementCountActions = require('../../user/elementCount/elementCountActions');

var _http = require('../../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _elementHelper = require('../../../common/elements/elementHelper');

var _undoRedoTransactionManager = require('../../utils/undoRedo/undoRedoTransactionManager');

var _boardConstants = require('../../../common/boards/boardConstants');

var _httpConstants = require('../../../common/utils/http/httpConstants');

var _elementConstants = require('../../../common/elements/elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prepareDuplicateContent = function prepareDuplicateContent(content) {
    return _extends({}, content, {
        title: content.title,
        documentMode: undefined
    });
};

var duplicateElement = exports.duplicateElement = function duplicateElement(_ref) {
    var duplicateId = _ref.duplicateId,
        location = _ref.location,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync,
        _ref$transactionId = _ref.transactionId,
        transactionId = _ref$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref$transactionId;
    return function (dispatch, getState) {
        var state = getState();
        var copyElement = state.getIn(['elements', duplicateId]);

        if (!copyElement) return;

        var elementType = (0, _elementHelper.isAlias)(copyElement) ? _boardConstants.BOARD_TYPE : copyElement.get('elementType');

        var newElementDef = {
            elementType: elementType,
            location: location,
            content: prepareDuplicateContent(copyElement.get('content').toJS()),
            meta: copyElement.get('meta'),
            duplicate: true,
            transactionId: transactionId
        };

        var elementId = dispatch((0, _elementActions2.createElement)(newElementDef));

        // don't continue if element creation wasn't successful
        var createdElement = getState().getIn(['elements', elementId]);
        if (!createdElement) return;

        if (!(0, _elementHelper.isContainer)(copyElement)) return;

        var postData = {
            element: JSON.stringify({
                id: elementId,
                location: location
            })
        };

        (0, _http2.default)({ url: 'elements/' + copyElement.get('id'), method: _httpConstants.METHODS.COPY, data: postData }).then(function (res) {
            dispatch({
                type: TYPES.ELEMENT_FORCE_LOAD,
                id: elementId,
                sync: true
            });

            dispatch((0, _elementCountActions.increaseElementCount)(res.data.elementCount, transactionId));
        }).catch(function (err) {
            if (!err.response) return console.error(err);

            var data = err.response.data;

            dispatch((0, _elementActions.deleteElement)({ id: elementId, location: location, transactionId: transactionId }));
            // TODO: show an error modal here
            alert(data.error && data.error.message); // eslint-disable-line no-alert
        });
    };
};

var duplicateMultipleElements = exports.duplicateMultipleElements = function duplicateMultipleElements(_ref2) {
    var duplications = _ref2.duplications,
        _ref2$transactionId = _ref2.transactionId,
        transactionId = _ref2$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref2$transactionId;
    return function (dispatch, getState) {
        duplications.forEach(function (duplication) {
            return dispatch(duplicateElement({
                duplicateId: duplication.id,
                location: duplication.location,
                transactionId: transactionId
            }));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/duplicate/elementDuplicateActions.js
// module id = 1976
// module chunks = 0